
/*
    Simple, consistent display for data values, with overrides for color and font size
*/

import React from "react";

const DataItem = (props) => {

    let color = "black";

    if(props.color){
        color = props.color.toLowerCase();
    }

    let fontSize = "inherit";
    if(props.fontSize){
        fontSize = props.fontSize;
    }

    return (
        <span style={
            {
                fontWeight:"bold", 
                color: `var(--${color})`, 
                fontSize
            }
        }>
            {props.val}
            {props.children}
        </span>
    );
}

export default DataItem;